export const functions_discount = {
    data: function () {
        return {
            discounts:[],
            discount:null,
        };
    },
    methods: {
        /**
         * Форматирует условия скидки
         * @param discount скидка
         * @returns string отформатированная стока с условиями скидки
         */
        discountCoditions: function (discount, rooms=null, tarifs=null) {
            //console.log('discountCoditions');
            if (!this.is(rooms)) {
                //console.log('discountCoditions 1');
                if (this.is(this.rooms) && this.rooms.length) {
                    //console.log('discountCoditions 2');
                    rooms = this.rooms;
                }
                else if (this.is(this.hotel.rooms) && this.hotel.rooms.length) {
                    //console.log('discountCoditions 3');
                    rooms = this.hotel.rooms;
                }
            }

            if (!this.is(tarifs)) {
                //console.log('discountCoditions 4');
                if (this.is(this.programs) && this.programs.length) {
                    //console.log('discountCoditions 5', this.programs);
                    tarifs = this.programs;
                }
                else if (this.is(this.hotel.tarifs) && this.hotel.tarifs.length) {
                    //console.log('discountCoditions 4');
                    tarifs = this.hotel.tarifs;
                }
            }

            if (!discount) { return ''; }
            discount.c_rows =[];
            if (this.is(discount.room_id) && rooms) {
                discount.c_rooms = rooms.filter(obj => {return obj.id === discount.room_id})
                if (!discount.c_rooms[0]) {
                    discount.c_rows.push("Ошибка JS00010003. Нарушена связность данных");
                }
                else {
                    discount.c_rows.push('Номер: ' + discount.c_rooms[0].title);
                }
            }

            if (this.is(discount.tarif_id) && tarifs) {
                discount.c_tarifs = tarifs.filter(obj => {return obj.id === discount.tarif_id})
                if (!discount.c_tarifs[0]) {
                    discount.c_rows.push("Ошибка JS00010004. Нарушена связность данных");
                }
                else {
                    discount.c_rows.push('Программа: ' + discount.c_tarifs[0].title);
                }
            }

            if (discount.early_booking) {
                discount.c_rows.push('Бронирование не позднее чем за: ' + discount.early_booking + ' дней');
            }

            if (discount.minimal_range) {
                discount.c_rows.push('Минимальный срок бронирования: ' + discount.minimal_range + ' дней');
            }

            if (discount.age_from!==null || discount.age_to!==null) {

                let text = 'Возраст:';
                if (discount.age_from) {
                    text += ' c ' + this.formatAge(discount.age_from);
                }
                if (discount.age_to) {
                    text += ' до ' + this.formatAge(discount.age_to);
                }

                discount.c_rows.push(text);
            }

            if (discount.place_type==1)
                discount.c_rows.push('Только для основных мест');
            if (discount.place_type==2)
                discount.c_rows.push('Только для дополнительных мест');
            if (discount.place_type==3)
                discount.c_rows.push('Только для Одноместного заселения');

            if (discount.sex==='M')
                discount.c_rows.push('Только для мужчин');
            if (discount.sex==='F')
                discount.c_rows.push('Только для женщин');

            return  discount.c_rows.join('<br>');
        },

        loadDiscounts: function (hotel_id, onSuccess=null, param=null) {
            if (!this.isDiscountsLoaded()) {
                this.discounts = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/discounts')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.discounts = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
        },

        loadDiscountsAll: function (hotel_id, onSuccess=null, param=null) {
            if (!this.isDiscountsLoaded()) {
                this.discounts = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/discounts/all')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.discounts = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
        },

        resetDiscounts: function () {
            this.discounts = [];
            return this;
        },

        isDiscountsLoaded: function () {
            return (this.discounts !== null) && this.discounts.length;
        },

        addDiscount: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.post(this.apiurl('discount/create/' + this.hotel_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.discounts.push(response.payload);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        enableDiscount(discount, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('discount/' + discount.id + '/enable')).then(function (response) {
                response = this.httpSuccess(response);
                let index = this.discounts.indexOf(discount);
                if (index !== -1) {
                    this.discounts.splice(index,1,response.payload);
                }
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        disableDiscount(discount, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('discount/' + discount.id + '/disable')).then(function (response) {
                response = this.httpSuccess(response);
                let index = this.discounts.indexOf(discount);
                if (index !== -1) {
                    this.discounts.splice(index,1,response.payload);
                }
            }, this.httpError)
        },

        cloneDiscount: function (discount, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.post(this.apiurl('discount/' + discount.id + '/clone')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    this.discounts.push(response.payload);
                    this.executeFunction(onSuccess, param, response.payload);
                }
                else {
                    this.error_log(response.error);
                }
            }, this.httpError)
        },

        deleteDiscount: function (discount, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('discount/' + discount.id + '/delete')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    let index = this.discounts.indexOf(discount);
                    if (index !== -1) {
                        this.discounts.splice(index, 1);
                    }
                    this.executeFunction(onSuccess, param);
                }
                else {
                    this.error_log(response.error);
                }
            }, this.httpError)
        },

        loadDiscount: function (discount_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('discount/' + discount_id )).then(function (response) {
                response = this.httpSuccess(response);
                this.discount = response.payload;
                this.executeFunction(onSuccess, param, response.payload );
            }, this.httpError)
        },

        saveDiscount: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('discount/'+this.discount.id+'/save'), this.discount).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

    },
    computed: {
        is_discount_loaded: function () {
            return (this.is(this.discount));
        },
    }
};
